import { render, staticRenderFns } from "./AbaCarregarPermissoesUsuario.vue?vue&type=template&id=22733ad8"
import script from "./AbaCarregarPermissoesUsuario.vue?vue&type=script&lang=ts"
export * from "./AbaCarregarPermissoesUsuario.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports